import { Image, TextInputProps } from "react-native";
import React from "react";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { SvgUri } from "react-native-svg";

type IndexProps = TextInputProps & {
  url?: string;
  width?: number;
  height?: number;
};

const Logo = (props: IndexProps) => {
  const { width, height, url } = props;
  const { companyLogo } = useOrgSettingsSlice();
  const isSvg = companyLogo?.split(".")?.includes("svg") && SvgUri;

  return (
    <>
      {companyLogo && isSvg ? (
        <SvgUri width={width} height={height} uri={companyLogo} />
      ) : (
        <Image
          style={{ width: width, height: height }}
          source={{
            uri: url ? url : companyLogo,
          }}
          resizeMode="contain"
        />
      )}
    </>
  );
};

export default Logo;
